<template>
  <div id="adminCrmBookingSettings">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">booking</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ Settings  }}</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin"> 
        <h1>{{ Settings }}</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewSettings"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableBookingSettingsConfiguration"
                  :datas="tableData"
                  id="tableCategories"
                  :onCheck="onTableCheckBookingSettings"
                  :onCheckAll="onTableCheckBookingSettings"
                  :onUncheck="onTableCheckBookingSettings"
                  :onUncheckAll="onTableCheckBookingSettings"
                  ref="tableCategories"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
           
            <div class="card-body" style="padding: 30px;">
              <div class="row">
                <pageDetail
                  functions="adminCrmBookingSettings"
                  :configurations="DetailBookingSettingsConfiguration"
                  :jsonValue="detailData"
                ></pageDetail>
              </div>
              <h1 style="margin-top: 10px; font-size: 30px; font-weight: lighter; color: rgb(48, 60, 84);">Opzioni visualizzazione testo su calendario</h1>
       <!-- <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" @click="ontabmounth">Mese</button>
                </li>

                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" @click="ontabweek">Settimana</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" @click="ontabday">Giorno</button>
                </li>
        </ul>

 <div class="tab-content" id="myTabContent">

      <div class="tab-pane fade show" id="tabledetailcalendaroptionmounth" role="tabpanel">
                <div class="row">
                  <div class="col-2" style="text-align:center"><label class="labelclass">Visualizza</label></div>
                  <div class="col-1" style="text-align:center; margin-left: -9px;"><label class="labelclass">Ordinamento</label></div>
                  <pageDetail
                    functions="adminCrmBookingSettings"
                    :configurations="DetBookSettOptionCalendarConfiguration"
                    :jsonValue="detailData"
                  ></pageDetail>
                </div>
        </div>
        <div class="tab-pane fade show" id="tabledetailcalendaroptionweek" role="tabpanel">
                <div class="row">
                   <div class="col-2" style="text-align:center"><label class="labelclass">Visualizza</label></div>
                  <div class="col-1" style="text-align:center; margin-left: -9px;"><label class="labelclass">Ordinamento</label></div>
                    <pageDetail
                    functions="adminCrmBookingSettings"
                    :configurations="DetBookWeekOptionCalendarConfiguration"
                    :jsonValue="detailData"
                  ></pageDetail>
                </div>
        </div>

        <div class="tab-pane fade show" id="tabledetailcalendaroptionday" role="tabpanel">
                <div class="row">
                   <div class="col-2" style="text-align:center"><label class="labelclass">Visualizza</label></div>
                  <div class="col-1" style="text-align:center; margin-left: -9px;"><label class="labelclass">Ordinamento</label></div>
                   <pageDetail
                    functions="adminCrmBookingSettings"
                    :configurations="DetBookDayOptionCalendarConfiguration"
                    :jsonValue="detailData"
                  ></pageDetail>
                  
               
                </div>
        </div>
  </div> -->
              
                          <div class="col-12">
                                <table class="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th scope="col">Mese</th>
                                        <th scope="col">Settimana</th>
                                        <th scope="col">Giorno</th>
                                      </tr>
                                    </thead>
                              
                                    <tbody> 
                                      <tr>
                                        <td>
                                          <div class="row" style="margin-left:0px;">
                                            <div class="col-2 nopadding"><label class="labelclass">Visualizza</label></div>
                                            <div class="col-1 nopadding"><label class="labelclass">Ordinamento</label></div>
                                            <pageDetail
                                              functions="adminCrmBookingSettings"
                                              :configurations="DetBookSettOptionCalendarConfiguration"
                                              :jsonValue="detailData"
                                            ></pageDetail>
                                          </div>
                                        </td>
                                        <td>
                                            <div class="row" style="margin-left:0px;">
                                              <div class="col-2 nopadding"><label class="labelclass">Visualizza</label></div>
                                              <div class="col-1 nopadding"><label class="labelclass">Ordinamento</label></div>
                                                <pageDetail
                                                functions="adminCrmBookingSettings"
                                                :configurations="DetBookWeekOptionCalendarConfiguration"
                                                :jsonValue="detailData"
                                              ></pageDetail>
                                            </div>
                                        </td>
                                      <td>
                                        <div class="row" style="margin-left:0px;">
                                        <div class="col-2 nopadding"><label class="labelclass">Visualizza</label></div>
                                        <div class="col-1 nopadding"><label class="labelclass">Ordinamento</label></div>
                                        <pageDetail
                                          functions="adminCrmBookingSettings"
                                          :configurations="DetBookDayOptionCalendarConfiguration"
                                          :jsonValue="detailData"
                                        ></pageDetail></div>
                                      </td>
                                      </tr>
                                    </tbody>
                                  </table>
                          </div>




              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewBookingSettings"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                   @click="confirmSaveNewBookingSettings"
                  ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminCrmBookingSettings",
  components: {
    BootstrapTable,
    Select2,
    PageDetail
  },

  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      registries: dictionaryHelpers.getDictionary("registries"),
      Settings: "Impostazioni",
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      DetailBookingSettingsConfiguration: [],
      DetBookSettOptionCalendarConfiguration: [],
      DetBookWeekOptionCalendarConfiguration: [],
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newTitleSettings: "Nuovo",
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
      id: 0,
      languagePageSetting: { content: null }
      },
      TableBookingSettingsConfiguration: [],
      DetBookDayOptionCalendarConfiguration: [],
      tableCustomerResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmBookingSettings = this;
    spinnerHelpers.show();
    this.languages = storageData.sIdLanguage();

    adminCrmBookingSettings.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

        adminConfigurationServices.getFunctionality(function(result) {
        adminCrmBookingSettings.TableBookingSettingsConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
        adminCrmBookingSettings.DetailBookingSettingsConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
        console.log(result.data);
        adminCrmBookingSettings.DetBookSettOptionCalendarConfiguration = result.data.tabsConfigurations[1].pageConfigurations;
        adminCrmBookingSettings.DetBookWeekOptionCalendarConfiguration = result.data.tabsConfigurations[2].pageConfigurations;
        adminCrmBookingSettings.DetBookDayOptionCalendarConfiguration = result.data.tabsConfigurations[3].pageConfigurations;

        adminCrmBookingSettings.loadTable();
    });
  },


  methods: {
    loadTable(ln) {
      var adminCrmBookingSettings = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      bookingsettingsServices.getAll(ln,function(result) {
        adminCrmBookingSettings.tableData = result.data;
        adminCrmBookingSettings.executeOpenDetail(result.data[0].id);
        spinnerHelpers.hide();
      });
    },

     languageChange(value) {
      spinnerHelpers.show();
      var adminCrmBookingSettings = this;
      this.languages = value;
      adminCrmBookingSettings.loadTable(value);
      spinnerHelpers.hide();
    },

   
  bookingsettingsFormatter(value, row, index, field) {
      var adminCrmBookingSettings = this;
      var html =
        '<div class="container-fluid nopadding" style="min-width:80px;">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmBookingSettings.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
         html +=
        '<button class="btn btn-info" onclick="adminCrmBookingSettings.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';
          html +=
        '<button class="btn btn-danger" onclick="adminCrmBookingSettings.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmInterventions.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div>";
      return html;
    },

     executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmBookingSettings = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
       if (adminCrmBookingSettings.rowIdSelected == row.id) {
          adminCrmBookingSettings.detailData = row;
        }
      });

      
    /*  bookingsettingsServices.getById(adminCrmBookingSettings.rowIdSelected, function(result) {
      adminCrmBookingSettings.detailData = result.data;
     });*/
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();

    },

    clone(id) {
      var adminCrmBookingSettings = this;
      var ln = adminCrmBookingSettings.languages;
      spinnerHelpers.show();
      bookingsettingsServices.clone(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmBookingSettings.loadTable(ln);
      });
    },

    delete(id) {
      var adminCrmBookingSettings = this;
      var ln = adminCrmBookingSettings.languages;
      spinnerHelpers.show();
      bookingsettingsServices.del(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmBookingSettings.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

    ontabmounth() {
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      $("#tabledetailcalendaroptionmounth").addClass("active");
      $("#tabledetailcalendaroptionday").removeClass("active");
      $("#tabledetailcalendaroptionweek").removeClass("active");
    },

    ontabweek() {
      $("#tabDetail").addClass("active");
      $("#tabledetailcalendaroptionweek").addClass("active");
      $("#tabTable").removeClass("active");
      $("#tabledetailcalendaroptionmounth").removeClass("active");
      $("#tabledetailcalendaroptionday").removeClass("active");
    },

    ontabday() {
      $("#tabDetail").addClass("active");
      $("#tabledetailcalendaroptionday").addClass("active");
      $("#tabTable").removeClass("active");
      $("#tabledetailcalendaroptionmounth").removeClass("active");
      $("#tabledetailcalendaroptionweek").removeClass("active");
      
    },




      onNewSettings() {
      spinnerHelpers.show();
      var adminCrmBookingSettings=this;
      this.detailData = {};
      this.detailData.captures = [];
      this.titleDetail = this.newCategories;
      this.rowIdSelected = 0;
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },


    onTableCheckBookingSettings() {
      var countRowSelected = this.$refs.tableCategories.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewBookingSettings() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelBookingSettings();
      }
    },

    executeCancelBookingSettings() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewBookingSettings() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewBookingSettings();
      }
    },

    executeSaveNewBookingSettings() {
      spinnerHelpers.show();
      var adminCrmBookingSettings = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.detailData.description)) {
        this.detailData.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        bookingsettingsServices.update(this.detailData, function(result) {
          adminCrmBookingSettings.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmBookingSettings.updateCompleted
          });
          notificationHelpers.success(adminCrmBookingSettings.updateCompleted);
          adminCrmBookingSettings.loadTable(adminCrmBookingSettings.languages);
          /*$("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");*/
        });
      } else {
        bookingsettingsServices.insert(this.detailData, function(result) {
          adminCrmBookingSettings.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmBookingSettings.insertCompleted
          });
          notificationHelpers.success(adminCrmBookingSettings.insertCompleted);
          adminCrmBookingSettings.loadTable(adminCrmBookingSettings.languages);
          /*$("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");*/
        });
      }
    },
  
   
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    }
  }

};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
    position: absolute;
    margin-top: 11px;
    z-index: 1;
}

.labelclass {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  padding: 0px 2px;
  margin: 0px 0px -2px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background: #FFFFFF;
}


.nav-tabs .nav-item {
  width: 33.33%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}
</style>